module.exports = __webpack_public_path__ + "static/bottle.c766ef0c.png";